import React, { useState } from 'react'
import Header from '../../Layout/Header'
import Overview from './Overview'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark } from '@fortawesome/free-solid-svg-icons'

export default function Fundraise() {
    const [isOpenpopup, setisOpenpopup] = useState(true)


    return (
        <div className='min-h-screen bg-cover text-white flex flex-col' style={{ backgroundImage: 'url("/assets/bg/Fundbg.svg")' }}>
            <div className='h-[90px]'><Header /></div>
            <div className='flex flex-1 items-center'>
                <div className='w-[90%] mx-auto py-5' style={{ fontFamily: "Barlow" }}>
                    <h1 className='text-center font-semibold text-2xl lg:text-3xl 2xl:text-4xl'>Fund Raising</h1>
                    <div className='flex flex-col lg:flex-row gap-5 mt-2'>
                        <div className='w-[100%] lg:w-1/3'>
                            <div className='bg-[#191919]/30 p-5 rounded-2xl'>
                                <h1 className='text-center text-lg'>Create New Fund Raise</h1>
                                <div className='space-y-3 2xl:space-y-4'>
                                    <div className='space-y-1 2xl:space-y-2 flex flex-col'>
                                        <label>Name</label>
                                        <input className='border border-[#E0E0E0]/50 px-5 py-1.5 2xl:py-2 outline-none rounded-full placeholder:italic placeholder:text-[#E0E0E0]/50' placeholder='Enter the Project Name'></input>
                                    </div>
                                    <div className='space-y-1 2xl:space-y-2 flex flex-col'>
                                        <label>Amount</label>
                                        <input className='border border-[#E0E0E0]/50 px-5 py-1.5 2xl:py-2 outline-none rounded-full placeholder:italic placeholder:text-[#E0E0E0]/50' placeholder='Enter the Amount'></input>
                                    </div>
                                    <div className='space-y-1 2xl:space-y-2 flex flex-col'>
                                        <label>Description</label>
                                        <textarea className='border border-[#E0E0E0]/50 px-5 py-1.5 2xl:py-2 outline-none rounded-2xl placeholder:italic placeholder:text-[#E0E0E0]/50' placeholder='Enter the Description'></textarea>
                                    </div>
                                    <div className='space-y-1 2xl:space-y-2 flex flex-col'>
                                        <label>ROI</label>
                                        <input className='border border-[#E0E0E0]/50 px-5 py-1.5 2xl:py-2 outline-none rounded-full placeholder:italic placeholder:text-[#E0E0E0]/50' placeholder='Enter the ROI'></input>
                                    </div>
                                    <div className='space-y-1 2xl:space-y-2 flex flex-col'>
                                        <label>Timeline</label>
                                        <input className='border border-[#E0E0E0]/50 px-5 py-1.5 2xl:py-2 outline-none rounded-full placeholder:italic placeholder:text-[#E0E0E0]/50' placeholder='Enter the end date'></input>
                                    </div>
                                    <div className='flex justify-center'>
                                        <button className='bg-[#25A2BB] duration-500 hover:text-[#25A2BB] hover:bg-white hover:font-semibold px-4 py-2 rounded-full cursor-pointer'>Create Now</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='w-[100%] lg:w-2/3'>
                            <Overview />
                        </div>
                    </div>
                </div>
            </div>
            {isOpenpopup && (
                <div className="fixed inset-0 flex items-center h-full  md:justify-center bg-[#000]/70 z-100 px-2 py-5 overflow-auto fade-up-slide">
                    <div className="bg-[#232323]/95 p-6 w-[90%] lg:w-[60%] rounded-xl shadow-lg mx-auto relative">
                        <div className='block md:hidden'><FontAwesomeIcon icon={faXmark} onClick={() => { setisOpenpopup(false) }} className='absolute right-3 top-3' /></div>
                        <div>
                            <h1 className='text-[#fff] text-xl font-bold text-center uppercase'>Power the pitch, profit from the play.</h1>
                            <div className='flex justify-center'>
                                <img className='w-3/12' src='/assets/others/ballpopup.svg'></img>
                            </div>
                            <p className='text-white text-center text-sm mt-4 uppercase'>Back your favorite clubs and players. This is the GoalDex Crowdfund Zone – where everyone is a game-changer. <br />
                                Launching soon – get ready to invest in greatness
                            </p>
                            <div className='flex justify-center mt-3'><button className='bg-[#D9D9D9]/40 rounded-full font-semibold px-10 py-2 cursor-pointer' onClick={() => { setisOpenpopup(false) }}>Let's Explore</button></div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}
